
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"20","height":"20","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M17.135 1.254H3.149c-.506 0-.99.198-1.348.55-.358.353-.559.831-.559 1.33v13.789c0 .499.201.977.559 1.33.357.352.842.55 1.348.55h13.986c.506 0 .99-.198 1.349-.55.357-.353.558-.831.558-1.33V3.134c0-.499-.2-.977-.558-1.33a1.922 1.922 0 00-1.349-.55zm.636 15.669a.622.622 0 01-.186.443.64.64 0 01-.45.184H8.871v-3.134h6.357c.227 0 .437-.12.55-.314a.62.62 0 000-.626.637.637 0 00-.55-.314H8.235a.64.64 0 00-.45.184.622.622 0 00-.186.443v3.76H3.15a.64.64 0 01-.45-.183.622.622 0 01-.185-.443V8.775h5.085v1.254c0 .223.122.43.318.542a.644.644 0 00.636 0 .625.625 0 00.318-.542V6.268a.625.625 0 00-.318-.543.644.644 0 00-.636 0 .625.625 0 00-.318.543v1.254H2.514V3.134c0-.166.067-.326.186-.443a.64.64 0 01.45-.184h8.9v6.895c0 .166.066.325.185.443a.64.64 0 00.45.184h2.543c.227 0 .437-.12.55-.314a.62.62 0 000-.627.638.638 0 00-.55-.313H13.32V2.507h3.814a.64.64 0 01.45.184c.119.117.186.277.186.443v13.789z","fill":"#B5B8B5"}})])
          )
        }
      }
    